import React from 'react';
import { cn } from '@/lib/utils';

interface OnlineStatusIndicatorProps {
  isOnline: boolean;
  lastSeen?: string;
  showTooltip?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const OnlineStatusIndicator: React.FC<OnlineStatusIndicatorProps> = ({
  isOnline,
  lastSeen,
  showTooltip = true,
  size = 'md',
  className
}) => {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4'
  };

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span
        className={cn(
          'rounded-full flex-shrink-0',
          sizeClasses[size],
          isOnline 
            ? 'bg-green-500 animate-pulse shadow-[0_0_6px_rgba(34,197,94,0.6)]' 
            : 'bg-gray-500'
        )}
        title={showTooltip ? (isOnline ? 'Online now' : `Last seen: ${lastSeen || 'Unknown'}`) : undefined}
      />
      {lastSeen && (
        <span className="text-xs text-gray-400">
          {isOnline ? 'Online' : lastSeen}
        </span>
      )}
    </div>
  );
};

export default OnlineStatusIndicator;
